import * as React from 'react';
import moment from 'moment';
import { getArtworkFromFiles } from '../../utils/media';
import { Track } from '../../models/track';
import { Album } from '../../models/album';

const PLACEHOLDER_ART = '/static/images/artwork-placeholder.png';

/**
 * Modern drafts list: each draft is a clickable card with artwork, a Draft
 * badge, relative time and a hover lift. Empty state is a friendly "all caught
 * up" panel.
 */
const DraftsList: React.FC<{
  drafts: (Track | Album)[];
  onOpen: (draft: Track | Album) => void;
}> = ({ drafts, onOpen }) => {
  if (!drafts || drafts.length === 0) {
    return (
      <div className="dl-empty">
        <span className="dl-empty-icon">
          <s-icon type="check" />
        </span>
        <s-text type="strong">You&apos;re all caught up</s-text>
        <s-text color="subdued">No drafts waiting to be published.</s-text>
      </div>
    );
  }

  return (
    <div className="dl-list">
      {drafts.map((draft, index) => {
        const art =
          getArtworkFromFiles(draft.files)?.thumbnail?.secure_url || PLACEHOLDER_ART;
        return (
          <button
            key={draft._id || index}
            type="button"
            className="dl-card"
            onClick={() => onOpen(draft)}
            aria-label={`Edit draft ${draft.title || 'Untitled'}`}
          >
            <img className="dl-art" src={art} alt={draft.title || 'Untitled'} />
            <span className="dl-body">
              <span className="dl-title-row">
                <span className="dl-title">
                  <s-text type="strong">{draft.title || 'Untitled'}</s-text>
                </span>
                <s-badge tone="caution">Draft</s-badge>
              </span>
              <s-text color="subdued">{moment(draft.createdAt).fromNow()}</s-text>
            </span>
            <span className="dl-chevron" aria-hidden="true">
              <s-icon type="edit" />
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DraftsList;
